import type { HTMLAttributes } from 'react';
import { cx } from '@/lib/cx';
import styles from './Container.module.css';

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  /** Constrain to reading width, for prose-heavy blocks. */
  narrow?: boolean;
}

/** The single horizontal rhythm every section is measured against. */
export function Container({ narrow = false, className, ...rest }: ContainerProps) {
  return <div className={cx(styles.container, narrow && styles.narrow, className)} {...rest} />;
}
